import React from 'react';
import { Box, Grid, Modal, Typography } from '@mui/material';
import MarketSearchBar from 'src/App/HOC/Header/MarketSearchBar';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { COLOR_RED } from 'src/const';

const SearchBarModal = ({
  open,
  setOpen,  
  OnBoardingSearchBox
}) => {
  return (
    <Modal
      open={open === 'open'}      
    >
      <Box
        sx={{
          background: '#fff',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'clamp(300px, 80vw, 800px)',
          height: '70vh',
          padding: '20px',
          outline: 'none',
          border: 'none',
          borderRadius: '12px',
        }}
      >
        <Grid container sx={{ position: 'relative' }}>
          <Box
            onClick={() => {
              setOpen('alreadyOpened');
            }}
            sx={{
              width: '36px',
              height: '36px',
              borderRadius: '900px',
              cursor: 'pointer',
              position: 'absolute',
              top: '0',
              right: '0',
              boxShadow: '0 2px 12px -6px #0003',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: COLOR_RED,
              transition: 'background-color 0.25s ease',
              '&:hover': {
                background: COLOR_RED + '88',
              },
            }}
          >
            <CloseRoundedIcon sx={{ color: '#fff' }} />
          </Box>
          <Grid item xs={12} sx={{ marginBottom: '20px' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              Searching for a market?
            </Typography>
          </Grid>
          <Grid item xs={12}>            
            {OnBoardingSearchBox()}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default SearchBarModal;
